import { Mail, Phone, MapPin } from "lucide-react";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1C2A39] text-[#E8E5DD] c4-grain"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-20 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="bg-white p-3 inline-block">
            <img
              src="/logo.png"
              alt="C4 Plumbing & Heating Ltd"
              className="h-16 w-auto object-contain"
            />
          </div>
          <p className="mt-6 text-sm leading-relaxed max-w-md text-[#C7CCD3]">
            C4 Plumbing &amp; Heating Ltd is a bathroom, kitchen and plumbing
            company who specialise in design and installation, based in
            Warsash and covering all of Hampshire and parts of Dorset. With
            30+ verified reviews on Checkatrade and a rating of 10/10.
          </p>
        </div>

        <div className="lg:col-span-3">
          <div className="font-heading text-xs uppercase tracking-[0.25em] text-[#E9D28B] font-semibold">
            Explore
          </div>
          <ul className="mt-5 space-y-3">
            {[
              { id: "services", l: "Services" },
              { id: "portfolio", l: "Portfolio" },
              { id: "about", l: "About" },
              { id: "testimonials", l: "Reviews" },
              { id: "quote", l: "Get a quote" },
            ].map((it) => (
              <li key={it.id}>
                <button
                  data-testid={`footer-nav-${it.id}`}
                  onClick={() => scrollTo(it.id)}
                  className="text-sm text-[#C7CCD3] hover:text-white transition-colors"
                >
                  {it.l}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="font-heading text-xs uppercase tracking-[0.25em] text-[#E9D28B] font-semibold">
            Contact
          </div>
          <ul className="mt-5 space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <Mail size={16} strokeWidth={1.5} className="text-[#E9D28B] mt-0.5" />
              <a
                data-testid="footer-email"
                href="mailto:c4plumbingheating@hotmail.com"
                className="text-[#C7CCD3] hover:text-white"
              >
                c4plumbingheating@hotmail.com
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Phone size={16} strokeWidth={1.5} className="text-[#E9D28B] mt-0.5" />
              <a
                data-testid="footer-phone"
                href="tel:+447402288642"
                className="text-[#C7CCD3] hover:text-white"
              >
                07402 288 642
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin size={16} strokeWidth={1.5} className="text-[#E9D28B] mt-0.5" />
              <span className="text-[#C7CCD3]">
                Warsash, Southampton — covering all of Hampshire &amp; parts of Dorset
              </span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <div className="text-xs text-[#9AA3AC]">
            © {year} C4 Plumbing &amp; Heating Ltd. All rights reserved.
          </div>
          <div className="text-xs text-[#9AA3AC]">
            Gas Safe Registered · Fully Insured · 12-Month Workmanship Guarantee
          </div>
        </div>
      </div>
    </footer>
  );
}
